import { Picker } from "@react-native-picker/picker";
import React from "react";
import { View, StyleSheet, type StyleProp, type ViewStyle } from "react-native";

interface LanguagePickerProps {
  value: string;
  onChange: (lang: string) => void;
  style?: StyleProp<ViewStyle>;
  textColor?: string;
}

export const SUPPORTED_LANGUAGES = [
  { code: "en", label: "English", nativeName: "English" },
  { code: "fr", label: "French", nativeName: "Français" },
  { code: "es", label: "Spanish", nativeName: "Español" },
  { code: "de", label: "German", nativeName: "Deutsch" },
  { code: "pt", label: "Portuguese", nativeName: "Português" },
  { code: "ru", label: "Russian", nativeName: "Русский" },
  { code: "tl", label: "Tagalog/Filipino", nativeName: "Tagalog" },
  { code: "it", label: "Italian", nativeName: "Italiano" },
  { code: "am", label: "Amharic", nativeName: "አማርኛ" },
  { code: "ko", label: "Korean", nativeName: "한국어" },
];

export default function LanguagePicker({
  value,
  onChange,
  style,
  textColor = "#111827",
}: LanguagePickerProps) {
  return (
    <View style={[styles.pickerContainer, style]} data-oid=":u6qdbi">
      <Picker
        selectedValue={value}
        onValueChange={onChange}
        style={[styles.picker, { color: textColor }]}
        dropdownIconColor={textColor}
        data-oid="1u4vg6m"
      >
        {SUPPORTED_LANGUAGES.map((lang) => (
          <Picker.Item
            key={lang.code}
            label={lang.nativeName}
            value={lang.code}
            data-oid="7f1b3jr"
          />
        ))}
      </Picker>
    </View>
  );
}

const styles = StyleSheet.create({
  pickerContainer: {
    borderWidth: 1,
    borderColor: "#ccc",
    borderRadius: 8,
    backgroundColor: "#fff",
    marginVertical: 4,
  },
  picker: {
    paddingHorizontal: 12,
    paddingVertical: 8,
  },
});
